import { AQLQueryType, CompositeType } from './types';

export const AQL_QUERY_TYPE = {
  TITLE: 'title' as AQLQueryType,
  DURATION: 'duration' as AQLQueryType,
  ORIGINAL_URL: 'original_url' as AQLQueryType,
  PUBLISHED_DATE: 'published_date' as AQLQueryType,
  CREATED_AT: 'created_at' as AQLQueryType,
  UPDATED_AT: 'updated_at' as AQLQueryType,
  GROUPS: 'groups' as AQLQueryType,
  LANGUAGE: 'language' as AQLQueryType,

  TRANSCRIPT: 'transcript' as AQLQueryType,
  BRAND_SAFETY_GARM: 'brand_safety_garm' as AQLQueryType,
  BRAND_SAFETY_IAB: 'brand_safety_iab' as AQLQueryType,
  NAMED_ENTITIES: 'named_entities' as AQLQueryType,
  LINKED_NAMED_ENTITIES: 'linked_named_entities' as AQLQueryType,
  TOPICS: 'topics' as AQLQueryType,
  KEYWORDS: 'keywords' as AQLQueryType,
  CONTEXTUAL: 'contextual' as AQLQueryType,

  ID: 'id' as AQLQueryType,
  NAME: 'name' as AQLQueryType,
  TYPE: 'type' as AQLQueryType,
  EXTERNAL_IDS: 'external_ids' as AQLQueryType,
  EXTRA_FIELDS: 'extra_fields' as AQLQueryType,
  AUDIO_COUNT: 'audio_count' as AQLQueryType,
  PODCAST_METADATA: 'podcast_metadata' as AQLQueryType,
  AUTHOR: 'author' as AQLQueryType,
  APPLE_STAR_RATING: 'apple_star_rating' as AQLQueryType,
  APPLE_RATING_COUNT: 'apple_rating_count' as AQLQueryType,
  APPLE_CATEGORIES: 'apple_categories' as AQLQueryType,
  PODCAST_TYPE: 'podcast_type' as AQLQueryType,

  ALL: 'all' as AQLQueryType,
  ANY: 'any' as AQLQueryType,
  NONE: 'none' as AQLQueryType,
};

export const COMPOSITE_TYPE = {
  ALL: 'all' as CompositeType,
  ANY: 'any' as CompositeType,
  NONE: 'none' as CompositeType,
};

export const SHOW_FILTER_TYPES = [
  AQL_QUERY_TYPE.NAME,
  AQL_QUERY_TYPE.AUTHOR,
  AQL_QUERY_TYPE.PODCAST_TYPE,
  AQL_QUERY_TYPE.APPLE_CATEGORIES,
  AQL_QUERY_TYPE.APPLE_STAR_RATING,
  AQL_QUERY_TYPE.APPLE_RATING_COUNT,
  AQL_QUERY_TYPE.AUDIO_COUNT,
];

export const EPISODE_FILTER_TYPES = [
  AQL_QUERY_TYPE.TITLE,
  AQL_QUERY_TYPE.PUBLISHED_DATE,
  AQL_QUERY_TYPE.DURATION,
  AQL_QUERY_TYPE.TRANSCRIPT,
  AQL_QUERY_TYPE.LANGUAGE,
];
